import React from "react";
import "./About.css";
import { BsFillPatchCheckFill } from "react-icons/bs";

import M2 from "../../Assets/mo2.jpg";

const educationsData = [
  {
    id: 1,
    title: "Fayoum University",
    filed: "Computer science Student",
    duration: "2020 - 2024 ",
  },
  {
    id: 2,
    title: "Udacity Nanodegree",
    filed: "Professional Web Development",
    duration: "3 Months",
  },
  {
    id: 3,
    title: "ITI Summer Training",
    filed: "MERN Stack Web Development",
    duration: "1 Month",
  },
  {
    id: 4,
    title: "ITI Summer Training",
    filed: "MERN Stack Web Development",
    duration: "1 Month",
  },
];

const skills = [
  {
    name: "HTML",
    value: "95",
  },
  {
    name: "CSS",
    value: "90",
  },
  {
    name: "JavaScript",
    value: "90",
  },
  {
    name: "TypeScript",
    value: "90",
  },
  {
    name: "DOM Manipulation",
    value: "85",
  },
  {
    name: "React",
    value: "90",
  },
  {
    name: "Redux",
    value: "85",
  },
  {
    name: "Next",
    value: "80",
  },
  {
    name: "Tailwind CSS",
    value: "80",
  },

  {
    name: "SASS",
    value: "85",
  },
  {
    name: "Git/GitHub",
    value: "85",
  },
  {
    name: "Command Line",
    value: "80",
  },
];

const About = () => {
  return (
    <section className="about" id="about">
      <h2 className="section-title">About Me </h2>
      <div className="container">
        <div className="info">
          <div className="about-image">
            <img src={M2} alt="" />
          </div>
          <p>
            I'm Mohamed Salah, experienced React developer with a strong
            foundation in HTML, CSS, and JavaScript. Holds a Udacity Nanodegree
            in Professional Front End Web Development and completed ITI
            training. Currently pursuing a Bachelor's degree in Computer
            Science. Created portfolio projects using React, Redux, Tailwind
            CSS, and SEO best practices. Passionate about creating visually
            appealing and user-friendly web applications. Committed to
            delivering high-quality solutions that exceed expectations.
          </p>
        </div>
        <h3> Skills</h3>

        <div className="education--skills">
          <div className="educations">
            {educationsData.map((item) => (
              <div key={item.id}>
                <h4>{item.title}</h4>
                <span>{item.filed}</span>
                <span>{item.duration}</span>
              </div>
            ))}
          </div>

          <div className="skills">
            <div className="experience__content">
              {skills.map((item, i) => (
                <article key={i} className="experience__details">
                  <BsFillPatchCheckFill className="experience__details-icon" />
                  <h4>{item.name}</h4>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
